import {
  PAYMENT_RESPONSE_SET,
  PAYMENT_RESPONSE_REMOVE,
} from './types';

export const removePaymentResponse = () => ({
  type: PAYMENT_RESPONSE_REMOVE,
});

export const setPaymentResponse = props => ({
  type: PAYMENT_RESPONSE_SET,
  data: props,
});



// WEBPACK FOOTER //
// ./src/app/actions/payment-response/index.js